<div class="section-loader body-bg" *ngIf="loading">
  <div class="loader-inner ball-beat">
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
<div class="mContent__header bg-primary py-3 px-5 flex-auto">
  <h1 class="text-white mb-1">Forms and Links</h1>
  <div class="mControls">
    <div class="input-group mr-auto">
      <mat-form-field appearance="outline" class="input-white no-error">
        <mat-label>Search</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input
          type="text"
          matInput
          [(ngModel)]="linkInfo.search"
          (keyup.enter)="onSearch()"
          placeholder="Search by title"
          aria-label="Search"
        />
        <button
          mat-button
          *ngIf="linkInfo.search"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="linkInfo.search = ''; onSearch()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div *ngIf="loggedInUser !== tutorRoleId">
      <div class="mControls__right">
        <div class="input-group">
          <button mat-raised-button (click)="updateEvent(null)">
            Add New
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  *ngIf="eventsSignUps?.length > 0"
  class="search-results flex-fill overflow-auto m-3"
  infiniteScroll
  [infiniteScrollDistance]="0"
  [infiniteScrollThrottle]="1000"
  (scrolled)="onScroll()"
  [scrollWindow]="false"
>
  <table class="table no-wrap m-0 table--hover">
    <thead>
      <tr>
        <th scope="col"></th>
        <th scope="col">Title</th>
        <th scope="col">Description</th>
        <th scope="col"></th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let event of eventsSignUps">
        <td (click)="detailEventSignup(event.id)" [ngSwitch]="event.icon">
          <span class="icon-24" *ngSwitchCase="'upcoming'">
            <img src="assets/images/calendar-icon.png" alt="upcoming" />
          </span>
          <span class="icon-24" *ngSwitchCase="'volunteer'">
            <img src="assets/images/volunteer-icon.png" alt="volunteer" />
          </span>
          <span class="icon-24" *ngSwitchCase="'tutoring'">
            <img src="assets/images/tutor-icon.png" alt="tutoring" />
          </span>
          <span class="icon-24" *ngSwitchCase="'reading'">
            <img src="assets/images/book-icon.png" alt="reading" />
          </span>
          <span class="icon-24" *ngSwitchCase="'miscellaneous'">
            <img
              src="assets/images/miscellaneous-icon.png"
              alt="miscellaneous"
            />
          </span>
          <span class="icon-24" *ngSwitchCase="'speaker'">
            <img src="assets/images/speaker-icon.png" alt="speaker" />
          </span>
          <span class="icon-24" *ngSwitchCase="'list'">
            <img src="assets/images/list-icon.png" alt="list" />
          </span>
          <span class="icon-24" *ngSwitchCase="'training'">
            <img src="assets/images/training-icon.png" alt="training" />
          </span>
        </td>
        <td (click)="detailEventSignup(event.id)">{{ event.title }}</td>
        <td (click)="detailEventSignup(event.id)">{{ event.description }}</td>
        <div *ngIf="loggedInUser !== tutorRoleId">
          <td>
            <a
              class="cursor-pointer icon-btn"
              (click)="updateEvent(event.id)"
              aria-hidden="false"
              aria-label="Edit"
            >
              <mat-icon matTooltip="Edit" aria-hidden="false" aria-label="Edit"
                >edit</mat-icon
              >
            </a>
          </td>
          <td>
            <a
              class="cursor-pointer icon-btn"
              (click)="deleteEvent(event)"
              aria-hidden="false"
              aria-label="Delete"
            >
              <mat-icon
                matTooltip="Delete"
                aria-hidden="false"
                aria-label="Delete"
                >delete</mat-icon
              >
            </a>
          </td>
        </div>
      </tr>
    </tbody>
  </table>
</div>

<div
  class="flex-fill d-flex flex-column align-items-center justify-content-center"
  *ngIf="!eventsSignUps?.length"
>
  <img src="assets/images/no-result.png" alt="" />
  <h3 class="text-center">No Records found</h3>
</div>

<div class="text-right flex-auto p-3 page-count">
  <span>{{ eventsSignUps?.length }}</span> of <span>{{ count }}</span>
</div>
